<template>
  <main id="main">
    <div class="header_page">
      <p id="title_header_page">{{ t('grades') }}</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.push({ name: 'Home' })">
    </div>

    <div class="p-3 pb-6">
      <div v-if="loading" class="text-center mt-5">
        <p>{{ t('loading') }}</p>
      </div>

      <div v-else class="d-flex flex-wrap justify-content-start">
        <div 
          v-for="grade in grades" 
          :key="grade.id" 
          style="width: 25%" 
          class="p-2" 
          @click="goToCourses(grade.id)"
        >
          <div class="custom_card">
            <div style="height: 7.7rem" class="bg_white rounded-5 p-3 shadow_box w-100 d-flex justify-content-center align-items-center">
              <img v-if="grade.pic" :src="grade.pic" class="w-100 h-100 object-fit-contain" alt="">
              <img v-else src="@/assets/imgs/knowledge_1.svg" class="icon-size-8" alt="">
            </div>
            <div class="bg_white rounded-pill p-3 shadow_box w-100 mt-2">
              <p class="text-center w-100 text_color_theme grade_text">{{ grade.title }}</p> 
            </div>
          </div>
        </div>
      </div>
    </div>
    <BottomNav />
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import { Decryption } from '@/utils/crypto.js'
import BottomNav from '@/components/BottomNav.vue'

export default {
  name: 'GradesListView',
  components: {
    BottomNav
  },
  data() {
    return {
      grades: [],
      loading: true
    }
  },
  mounted() {
    this.fetchGrades()
  },
  methods: {
    async fetchGrades() {
      try {
        const userId = localStorage.getItem('user_id')
        const formData = createFormData({
          action: 'grade',
          user_id: userId
        })

        const response = await apiClient.post('/public_info', formData)

        if (response.data.status === true && response.data.data) {
          const realData = Decryption(response.data.data)
          this.grades = realData
        } else if (Array.isArray(response.data)) {
           this.grades = response.data
        }

      } catch (error) {
        console.error("خطا:", error)
      } finally {
        this.loading = false
      }
    },
    goToCourses(id) {
      this.$router.push({ name: 'GradeCourses', params: { gradeId: id } })
    }
  }
}
</script>

<style scoped>
.custom_card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-width: 8rem;
  height: 12.5rem;
  cursor: pointer;
}
.object-fit-contain {
  object-fit: contain;
}
.grade_text {
  font-size: 1.1rem;
  font-weight: bold;
}
</style>